import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PprService {

  readonly rootUrl = environment.apiUrl;

  constructor(private http: HttpClient) { }

  getPprTypes(): Observable<any> {
    return this.http.get(this.rootUrl + '/api/Modules/pprtypes');
  }

  requestPPR(module, facilityId, elaborazioneId, request, customdatestart?, customdateend?): Observable<any> {
    const dataWithoutOptionalParameters = '?module=' + module + '&facilityId=' + facilityId + "&elaborazioneId=" + elaborazioneId + "&request=" + request;
    const dataWithOptionalParameters = '?module=' + module + '&facilityId=' + facilityId + "&elaborazioneId=" + elaborazioneId + "&request=" + request + "&customdatestart=" + customdatestart + "&customdateend=" + customdateend;

    if (customdatestart == null && customdateend == null)
      return this.http.get(this.rootUrl + '/api/Modules/request' + dataWithoutOptionalParameters);

    else
      return this.http.get(this.rootUrl + '/api/Modules/request' + dataWithOptionalParameters);
  }

  viewPPR(reportId): Observable<any> {
    const data = '?reportId=' + reportId;
    return this.http.get(this.rootUrl + '/api/Modules/viewppr' + data);
  }
}
